import { map } from "lodash";
import dayjs from "dayjs";
import EncounterEntries from "../EncounterEntries";
import { mergedSexualOptions } from "../../../../../slices/options/sexual";
import { parseQuestionnaireDate } from "../../../../../utils/DateUtils";

// function to remove NullObjects & arrays
function removeNull(arr: any) {
  return arr.filter((element) => element !== null);
}
// Regular expression for the date format
const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
const isLoincCode = /LA\d+-\d/; // match strings that start with "LA" followed by one or more digits
const isUUID =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/; // Matches UUID-like strings
function findItemByCode(codeToFind) {
  const foundItem = mergedSexualOptions.find(
    (item) => item.code === codeToFind.trim(),
  );
  if (foundItem) {
    return foundItem.display;
  }
  return "Item not found";
}

const getPregnancyHistoryData = (value: Record<string, any>) => {
  const data = [];

  if (value.pregnancyDate) {
    data.push(`Date: ${dayjs(value.pregnancyDate).format("MM/YYYY")}`);
  }
  if (value.term) {
    data.push(`Term: ${value.term}`);
  }
  if (value.preterm) {
    data.push(`Preterm: ${value.preterm}`);
  }
  if (value.termination) {
    data.push(`Termination: ${value.termination}`);
  }

  if (value.living) {
    data.push(`Living: ${value.living}`);
  }

  if (value.sex) {
    data.push(`Sex: ${value.sex}`);
  }

  if (value.deliveryMethod) {
    data.push(`Delivery Method: ${value.deliveryMethod}`);
  }

  if (value.outcome) {
    data.push(`Outcome: ${value.outcome}`);
  }

  if (value.complications) {
    data.push(`Complications: ${value.complications}`);
  }

  if (value.procedures) {
    data.push(`Procedures: ${value.procedures?.coding?.[0]?.display}`);
  }

  return data.join(" · ");
};

function printQuestionsAndAnswers(arr: any, entries) {
  for (let o = 0; o < arr.length; o++) {
    if (arr[o]) {
      if (
        isLoincCode.test(arr[o]?.answer?.value) ||
        isUUID.test(arr[o]?.answer?.value)
      ) {
        entries.push({
          text: `${arr[o]?.text}: ${findItemByCode(arr[o]?.answer?.value)}`,
        });
      } else if (arr[o]?.answer?.value === "true") {
        entries.push({ text: `${arr[o]?.text}: ${" Yes\n"}` });
      } else if (arr[o]?.answer?.value === "false") {
        entries.push({ text: `${arr[o]?.text}: ${" No\n"}` });
      } else if (dateRegex.test(arr[o]?.answer?.value)) {
        entries.push({
          text: `${arr[o]?.text}: ${parseQuestionnaireDate(arr?.[o]?.answer)}`,
        });
      } else if (arr[o]?.text !== undefined && arr[o]?.answer?.value) {
        if (arr[o].id === "pregnancyHistory") {
          entries.push({
            text: `${arr[o]?.text}: ${arr[o].answer.value.map(getPregnancyHistoryData).join(";\n")}`,
          });
          return;
        }

        entries.push({
          text: `${arr[o]?.text}: ${
            arr[o]?.answer?.value?.display
              ? arr[o]?.answer?.value.display
              : arr[o]?.answer?.value
          }`,
        });
      } else if (
        arr[o]?.text !== undefined &&
        Array.isArray(arr[o]?.answer) &&
        arr[o]?.answer.length > 0
      ) {
        entries.push({
          text: `${arr[o]?.text}: ${map(arr[o].answer, "value.display").join(
            ", ",
          )}`,
        });
      }
      if (arr[o]?.item) {
        printQuestionsAndAnswers(arr[o].item, entries);
      }
    }
  }
}

export const renderSexualHistoryEntry = (entry, readonly) => {
  const { item, note } = entry;

  const entries = [];

  if (item?.length > 0) {
    // use function that removes null object and arrays
    const newItem = removeNull(item);
    printQuestionsAndAnswers(newItem, entries); 
  }
  if (note?.length > 0) {
    note.forEach((n) => {
      entries.push({ text: `${n.text}` });
    });
  }
  return (
    <EncounterEntries type="history" entries={entries} readonly={readonly} />
  );
};
